import { render } from "./TNMExtract.vue?vue&type=template&id=31c38638"
import script from "./TNMExtract.vue?vue&type=script&lang=js"
export * from "./TNMExtract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__